import { Button } from 'antd';
import styled from 'styled-components';

export const WrapContainer = styled.div`
  overflow-x: hidden;
  background-color: white;
  padding: 25px 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 4px 12px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  max-width: 1000px;
  width: calc(100% - 40px);
  margin: 3em;
`;

export const SubWrapContainer = styled.div`
  max-width: 850px;
  width: 100%;
  margin: 0 auto;
`;
export const HeaderWrap = styled.div`
  text-align: center;
  margin-top: 24px;
  margin-bottom: 24px;
`;

export const Header = styled.h3`
  margin: 0;
`;

export const SubHeaderWrap = styled.div`
  margin-top: 10px;
  margin-bottom: 30px;
  &.emailHeader {
    display: flex;
  }
`;
export const SubHeader = styled.div`
  font-weight: bold;
`;
export const SubHeaderChild = styled.div`
  font-style: italic;
  &.marginLeft {
    margin-left: 10px;
  }
`;

export const ContentWrap = styled.div`
  & .ant-form-item {
    width: 100%;
  }
  &.centerContent {
    display: flex;
    justify-content: center;
  }
  margin-top: 1.5em;
`;
export const FormWrap = styled.div``;

export const FormColWrap = styled.div`
  display: flex;
  gap: 50px;

  @media (max-width: 760px) {
    display: block;
  }
  &.singleBox {
    width: 47%;
    @media (max-width: 750px) {
      width: 100%;
    }
  }
`;

export const FormRowWrap = styled.div``;

export const StyledFormItem = styled.div`
  display: flex;
  justify-content: end;
`;

export const StyledButton = styled(Button)`
  height: 40px;
  width: 120px;
`;
